// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

export enum QuestionInputType {
    TEXT,
    PARAGRAPH,
    SINGLE_SELECT,
    MULTI_SELECT,
    NUMBER

}
export default QuestionInputType
